import Swiper from 'swiper'; 
import { EffectFade, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';

const newsStickyCarousel = () => {
    const swiperSlider = () => {
        const carousel = document.querySelector('.sticky-posts.swiper');

        if (!carousel) return;
        
        const siteContent = document.querySelector('.site-content');
        siteContent.style.overflowX = 'hidden'; // Prevent horizontal scroll

        let previousIndex = 0; // Track the previous slide index

        const swiper = new Swiper(carousel, {
            loop: false,
            spaceBetween: 0,
            effect: 'fade',
            modules: [EffectFade, Pagination, Navigation],
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        });

        const updateSlideTransform = () => {
            const wrapper = carousel.querySelector('.swiper-wrapper');
            const wrapperWidth = wrapper.offsetWidth;

            carousel.querySelectorAll('.swiper-slide').forEach((slide, slideIndex) => {
                const content = slide.querySelector('.content');
                const image = slide.querySelector('.image');
                const distanceFromActive = slideIndex - swiper.activeIndex;

                // get css % width of image
                const imageWidth = image.offsetWidth;
                const imageWidthPercentage = imageWidth / wrapperWidth * 100;
                const imageWidthPercentageFormatted = imageWidthPercentage / 100;

                if (slideIndex > swiper.activeIndex) {
                    // Adjust the offset for the next slides
                    const offset = distanceFromActive * (wrapperWidth * imageWidthPercentageFormatted);
                    image.style.transform = `translate3d(${offset + 5}px, 0, 0)`;
                    image.style.opacity = 1;
                } else if (slideIndex === swiper.activeIndex) {
                    // Active slide in full view
                    image.style.transform = 'translate3d(0, 0, 0)';
                    image.style.opacity = 1;
                } else {
                    // Hide previous slides
                    image.style.transform = 'translate3d(-56px, 0, 0)';
                    image.style.opacity = 0;
                }
            });
        };

        // Initial setup
        updateSlideTransform();

        // Update the transform and apply animations whenever the slide changes
        swiper.on('slideChangeTransitionStart', () => {
            const currentIndex = swiper.activeIndex;
            const direction = currentIndex > previousIndex ? 'right' : 'left';

            swiper.slides.forEach((slide) => {
                slide.querySelectorAll('.content').forEach((el) => {
                    el.classList.remove('fadeInLeft', 'fadeInRight');
                });
            });

            const currentSlide = swiper.slides[currentIndex];
            if (currentSlide) {
                currentSlide.querySelectorAll('.content').forEach((el) => {
                    el.classList.add(direction === 'right' ? 'fadeInRight' : 'fadeInLeft');
                });
            }

            previousIndex = currentIndex;
            updateSlideTransform();
        });

        // Reset opacity and other styles after transition completes
        swiper.on('slideChangeTransitionEnd', () => {
            swiper.slides.forEach((slide) => {
                slide.querySelectorAll('.content, .image').forEach((el) => {
                    el.style.opacity = '1';
                });
            });
        });
    }

    swiperSlider();
}

export default newsStickyCarousel;